import api from './api';

export interface ClientePredeterminadoSucursalDto {
  nroSuc: number;
  nroCliente: number | null;
  nombre: string | null;
  tipoIva: string | null;
  cuit: string | null;
  configurado: boolean;
}

const normalizeClientePredeterminado = (
  raw: Record<string, unknown>,
  fallbackNroSuc = 0,
): ClientePredeterminadoSucursalDto => {
  const nroClienteRaw = raw.nroCliente ?? raw.NroCliente;
  const nroClienteNum =
    nroClienteRaw == null || nroClienteRaw === '' ? null : Number(nroClienteRaw);
  const nroCliente =
    nroClienteNum != null && Number.isFinite(nroClienteNum) && nroClienteNum > 0
      ? nroClienteNum
      : null;

  return {
    nroSuc: Number(raw.nroSuc ?? raw.NroSuc ?? fallbackNroSuc) || fallbackNroSuc,
    nroCliente,
    nombre: (raw.nombre ?? raw.Nombre ?? null) as string | null,
    tipoIva: (raw.tipoIva ?? raw.TipoIva ?? null) as string | null,
    cuit: (raw.cuit ?? raw.Cuit ?? null) as string | null,
    configurado: Boolean(raw.configurado ?? raw.Configurado ?? nroCliente != null),
  };
};

/**
 * Cliente predeterminado por sucursal.
 * GET/PUT /api/VentasConfig/cliente-predeterminado
 */
const ventasConfigService = {
  getClientePredeterminado: async (nroSuc: number): Promise<ClientePredeterminadoSucursalDto> => {
    const resp = await api.get('/api/VentasConfig/cliente-predeterminado', {
      params: { nroSuc },
    });
    const data = resp?.data;
    if (data && typeof data === 'object') {
      return normalizeClientePredeterminado(data as Record<string, unknown>, nroSuc);
    }
    return {
      nroSuc,
      nroCliente: null,
      nombre: null,
      tipoIva: null,
      cuit: null,
      configurado: false,
    };
  },

  setClientePredeterminado: async (
    nroSuc: number,
    nroCliente: number | null,
  ): Promise<ClientePredeterminadoSucursalDto> => {
    const payload = {
      nroSuc,
      nroCliente: nroCliente != null && nroCliente > 0 ? nroCliente : null,
    };
    const resp = await api.put('/api/VentasConfig/cliente-predeterminado', payload);
    const data = resp?.data;
    if (data && typeof data === 'object') {
      return normalizeClientePredeterminado(data as Record<string, unknown>, nroSuc);
    }
    return {
      nroSuc,
      nroCliente: payload.nroCliente,
      nombre: null,
      tipoIva: null,
      cuit: null,
      configurado: payload.nroCliente != null,
    };
  },
};

export default ventasConfigService;
